import * as React from 'react';
export function formatStructuredValue(value) {
  if (typeof value === 'string') {
    return value;
  }
  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return String(value);
  }
}
export function shouldCollapsePayload(text) {
  return text.length > 320 || text.split('\n').length > 8;
}
export function safeUri(uri) {
  if (uri == null || uri === '') {
    return '';
  }
  try {
    const trimmed = uri.trim();
    if (trimmed.startsWith('#') || trimmed.startsWith('/')) {
      return trimmed;
    }
    const parsed = new URL(trimmed, 'https://mui.com');
    const protocol = parsed.protocol.toLowerCase();
    if (protocol === 'http:' || protocol === 'https:' || protocol === 'mailto:' || protocol === 'tel:') {
      return trimmed;
    }
    return '';
  } catch {
    return '';
  }
}
export function normalizeMarkdownForRender(markdown) {
  const fenceMatches = markdown.match(/```/g);
  if ((fenceMatches?.length ?? 0) % 2 === 1) {
    return `${markdown}\n\`\`\``;
  }
  return markdown;
}
export function extractLanguage(className) {
  const match = /language-([^\s]+)/.exec(className ?? '');
  return match?.[1]?.trim().toLowerCase() ?? '';
}
export function normalizeCodeContent(value) {
  const text = React.Children.toArray(value).join('');
  return text.replace(/\n$/, '');
}